import React from 'react';

interface SubmitButtonProps {
  loading: boolean;
  expenseType: '지출기록' | '송금기록';
}

const SubmitButton: React.FC<SubmitButtonProps> = ({
  loading,
  expenseType
}) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 max-w-screen-md p-4 mx-auto w-full bg-white">
      <button
        type="submit"
        disabled={loading}
        className="w-full py-3.5 px-4 bg-blue-500 text-white text-lg font-semibold rounded-xl"
      >
        {loading 
          ? '처리 중...' 
          : expenseType === '송금기록' 
            ? '송금 기록하기' 
            : '지출 등록하기'
        }
      </button>
    </div>
  );
};

export default SubmitButton; 